module.exports = __webpack_public_path__ + "static/circled-check.37a32d37.svg";